// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-main[data-v-2926d9cd]{background-color:#fff!important}", ""]);
// Exports
module.exports = exports;
